/**
 * 页面组件实例
 */
let pageInstance = null;
/**
 * 当前页面组件列表的ref
 */
let pageComponentRefs = [];
/**
 * 页面方法
 */
const pageMethod = {
  getCustomComponentData(index) {
    return pageInstance.state.eles[index];
  },
  setCustomComponentData(index, data) {
    let newData = {};
    newData['eles['+index+']'] = data;
    pageInstance.setData(newData);
  }
}
/**
 * 设置当前页面实例
 * @param {object} instance 
 */
const setPage = (instance) => {
  pageInstance = instance;
  pageComponentRefs = [];
}
export {
  setPage,
  pageInstance,
  pageMethod,
  pageComponentRefs
};


// WEBPACK FOOTER //
// ./src/utils/page.jsx